import {useEffect, useState} from 'react'
import { useNavigate} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'






export function ForgotPassword() {
  const navigate=useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState("")
  const [email,setEmail]=useState("")
  
  const validateEmail=async()=>{
   
    if(email==="" || email===null || email===undefined)
    {
        setHasErrors("Email Is Required")
    }
    else
    {
      
      forgotpasswordapicall()
    }
  }

  const forgotpasswordapicall=async()=>{
    var param:any={
      email:email
    }
    var response:any=await fetchData("admin/forgotpassword",param)
    
    if(response.status=="200")
    {      

      toastsuccessmsg("OTP Send Successfully")
      navigate("../reset-password");
      
    }
    else
    {
      setLoading(false)
      toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    document.title = 'Insayr | Forgot Password'; 
  },[])

  return (
    <>
    
    <ToastContainer />
    <div className='bg-body d-flex flex-column flex-center rounded-4 w-md-600px p-10'>
      <div className='d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-400px'>
        <div
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          // noValidate
          id='kt_login_password_reset_form'
        >
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='text-gray-500 fw-semibold fs-6'>
              Enter your mobile number to reset your password.
            </div>
            {/* end::Link */}
          </div>      
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-8'>
            
             <label className="col-lg-4 col-form-label fw-bold fs-6">
                <span className="required">Email</span>

            </label>
            {/* <!--end::Label--> */}
            <div className="col-lg-8 fv-row fv-plugins-icon-container d-lg-flex d-md-flex d-xl-flex align-items-center w-100">            
                <input
                  className="form-control form-control-solid w-100"
                  placeholder='Enter Email'
                  value={email}
                  type='text'
                  onChange={(e:any)=>setEmail(e.target.value)}
                />
            </div>
            <span className='text-danger mt-3'>{hasErrors}</span>
            {/* <!--end::Col--> */}
            
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button type='button' id='kt_password_reset_submit' className='btn btn-success monthDiv me-4' onClick={()=> validateEmail()}>
              <span className='indicator-label'>Submit</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            {' '}
          </div>
          {/* end::Form group */}
        </div>
      </div>
    </div>
    </>
  )
}
